import { ofType, ActionsObservable } from 'redux-observable';
import { map, mergeMap, flatMap } from 'rxjs/operators';
import { from } from 'rxjs';
import { TransformResponse } from './transform';
import {
    TransformCaller
} from '../../source/src/transformCaller';
import { TransformResponse as TransformCallerDestResponse } from '../../calleddest/src/transform';
import { format } from 'one-util-date';

import {
    addAction
} from 'one-state-error/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';

import {
    setAction as setSkeletonAction
} from 'one-state-skeleton';
import {
    Skeleton
} from 'one-model-local';
import {
    setSelectedAction,setPatientSelectedAction,
    addAction as addSubjectAction
} from 'one-state-subject/src/actions';
import {
    selectAction as sourceSelectAction,
    addAction as sourceAddAction,
    setAction as setSource
} from 'one-state-source-local';

import axios from 'axios';
import {
    setNotificationAction
} from 'one-state-errorhandle';
import {
    setAction,
    reinitAction
} from 'one-state-calldest/src/action';
import { Disposition } from 'one-model-local';

import {
setAction as lookupErrorSet,
} from "one-state-subjecterror/src/action";


export const enum Types {
    GetSubjects = 'caller-patient',
    PushtoSubject = 'one-state-subject/set',
    GetDrawer = 'one-patient-drawer/set',
    HEALTHALERT = 'healthAlert',
    ConsolidateAPIOne = 'consolidated-api-one',
    SETCALLERDBDETAILS = 'one-state-source/set',
    STORE_DISPOSITION_CODE = "store-disposition-code",
}


const pushToSubject = (payload: any) => ({ type: Types.PushtoSubject, payload });
// const pushToSelect = (payload: any) => setSelectedAction(payload);
const pushToDrawer = (payload: any) => ({ type: Types.GetDrawer, payload });
const pushToSkeleton = (payload: any) => setSkeletonAction(payload);

const pushtoSETCallerDBPatient = (payload: any) => ({ type: Types.SETCALLERDBDETAILS, payload });
const pushToDisposition = (payload: any) => ({ type: Types.STORE_DISPOSITION_CODE, payload });

/**
 * This Fuction will fetch the data form EPIC Patient Lookup API
 * from backend api and returns the response and calls
 * subsequent redux action
 * @param context contains the settings etc..
 */

export const fetchPatientsEpic = (context: any) => (
    (action$: ActionsObservable<any>, state$: any) => {
        const errorTime = format(new Date(), 'LT');
        const errorDate = format(new Date(), 'LL');
        const { server, log, agentId, alertnotification, settings: { compatible, epicendpoints: { getpatientepic, apitoken } } } = context;
        const { contact_center_type } = compatible;
        return action$.pipe(
            ofType(Types.GetSubjects),
            mergeMap(action => {
                /**
                 * @param dataresponse contains the patient response
                 */
                const dataresponse: any = action.payload;
                let data:any = {}
                let callType = sessionStorage.getItem("callType")
                log.debug("one-epic", "patientEpic request", dataresponse);
                const getRequest = (reqresponse: any) => {
                    let respreturn;
                    if (reqresponse) {
                        let headers = new Headers();
                        headers.append("Accept", "application/json");
                        //  todo: delegate to one-server-ha oneview
                        headers.append("Authorization", "Basic " + apitoken?.token);
                        headers.append("Content-Type", "text/plain");
                        if(contact_center_type === "finesse") {
                            if(reqresponse?.subjectid) {
                                data = {
                                    "PatientID": reqresponse.subjectid,
                                    "UserID": reqresponse.userid ? reqresponse.userid : "",
                                    "UserIDType": reqresponse.useridtype ? reqresponse.useridtype : "",
                                }
                            }
                            else if(reqresponse?.sourceid) {
                                data = {
                                    "PatientID": reqresponse.sourceid,                        
                                    "UserID": reqresponse.userid ? reqresponse.userid : "",
                                    "UserIDType": reqresponse.useridtype ? reqresponse.useridtype : "", 
                                }
                            }
                            else {
                                data = {
                                    "PhoneNumber": reqresponse.number ? reqresponse.number : "",
                                    "UserID": reqresponse.userid ? reqresponse.userid : "",
                                    "UserIDType": reqresponse.useridtype ? reqresponse.useridtype : "",
                                }
                            } 
                        }
                        else if(contact_center_type === "vonage"|| contact_center_type === "wxcc" || contact_center_type === "five9") {

                            if(reqresponse.subjectid) {
                                data = {
                                    "PatientID": reqresponse.subjectid,
                                    "UserID": reqresponse.userid ? reqresponse.userid : "",
                                    "UserIDType": reqresponse.useridtype ? reqresponse.useridtype : "",
                                }
                            }
                            else if(reqresponse.sourceid) {
                                data = {
                                    "PatientID": reqresponse.sourceid,
                                    "UserID": reqresponse.userid ? reqresponse.userid : "",
                                    "UserIDType": reqresponse.useridtype ? reqresponse.useridtype : "", 
                                }
                            }
                            else {
                                data = {
                                    "PhoneNumber": reqresponse.number ? reqresponse.number : "",
                                    "UserID": reqresponse.userid ? reqresponse.userid : "",
                                    "UserIDType": reqresponse.useridtype ? reqresponse.useridtype : "",
                                }   
                            }
                        }
                        const response = server.post({
                            path: getpatientepic,
                            data: data,
                            headers: headers
                        })
                            .then((resp: any) => resp)
                            .catch((responseerror: any) => {
                                log.error("one-epic", "patientEpic Error", responseerror);
                                // SEND to ALERT notificaiton/NOC servers for critical error on no active server
                                if (responseerror?.status === 0) {
                                    if (alertnotification?.isEnabled()) {
                                        var timestamp = new Date().toJSON();
                                        alertnotification.notify({
                                            "error_code": "930-31",
                                            "error_type": "SERVER_ERROR",
                                            "error_description": "Unable to reach active servers",
                                            "error_supertype": "SERVER_FAILS",
                                            "error_detail": "Unable to reach any of server for retring data ",
                                            "alert": "Yes",
                                            "timestamp": timestamp,
                                            "params": responseerror
                                        });
                                    }
                                }
                                let subjecterror: ErrorObject = {
                                    source: "Subject",
                                    type: "error",
                                    status: responseerror?.status,
                                    erroritems: responseerror?.errors,
                                    error_date: errorDate,
                                    error_time: errorTime
                                };
                                return subjecterror;
                            })
                        respreturn = from(response);
                    } else {
                        respreturn = from([]);
                    }
                    log.debug("one-epic", "patientEpic response", respreturn);
                    return respreturn;
                }
                return getRequest(dataresponse).
                    pipe(
                        map(response => TransformResponse(response, context))).
                    pipe(
                        flatMap((response: any) => {
                            const actions: any = [
                                pushToSubject(response.subjectdata)
                            ];
                            //For Subject
                            const selected = response?.subjectdata?.find(
                                (item: any) => item?.id === dataresponse?.subjectid
                            );
                            if (selected && 'id' in selected) {
                                actions.push(setSelectedAction(selected));
                            }
                            //For Source
                            const sourceselected = response?.subjectdata?.find(
                                (item: any) => item?.id === dataresponse?.sourceid
                            );
                            if (sourceselected && 'id' in sourceselected) {
                                actions.push(sourceAddAction(sourceselected));
                                actions.push(sourceSelectAction(sourceselected?.id));
                                //Making skeleton to false
                                let skeletonsource: Skeleton = {
                                    source_skeleton: false
                                }
                            actions.push(pushToSkeleton(skeletonsource));
                            }
                            //Making skeleton to false
                            let skeletonsource: Skeleton = {
                                subject_skeleton: false,
                                source_skeleton:false
                            }
                            actions.push(pushToSkeleton(skeletonsource));
                            // check for error messages.
                            if (response.error) {
                                actions.push(addAction(response.error));
                                //To store the error object in the reducer.
                                actions.push(lookupErrorSet(response.error));
                                let disp: Disposition = { value: "997" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    disp.meta00 = agentIdValue;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta01 = response?.error?.status;
                                disp.meta02 = response?.error?.erroritems[0]?.error_detail;
                                disp.meta03 = 'client';
                                actions.push(pushToDisposition(disp));
                            } else {
                                let disp: Disposition = { value: "180" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    disp.meta00 = agentIdValue;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta01 = '200';
                                disp.meta02 = 'client';
                                actions.push(pushToDisposition(disp));
                            }
                            return actions;
                        })
                    )
            })
        )
    }
);


/**
 * This Fuction will fetch the data form Consolidated API#1
 * from backend api and returns the response and calls
 * subsequent redux action
 * @param context contains the settings etc..
 */

export const fetchConsolidatedAPIOneEpic = (context: any) => (
    (action$: ActionsObservable<any>, state$: any) => {
        const errorTime = format(new Date(), 'LT');
        const errorDate = format(new Date(), 'LL');
        const { serverone, log, agentId, alertnotification, settings: { compatible, epicendpoints: { consolidated_api_one, apitoken } } } = context;
        const { contact_center_type } = compatible;
        return action$.pipe(
            ofType(Types.ConsolidateAPIOne),
            mergeMap(action => {
                /**
                 * @param dataresponse contains the patient request
                 */
                const dataresponse: any = action.payload;
                log.debug("one-epic", "patientEpic request", dataresponse);
                const getRequest = (reqresponse: any) => {
                    let respreturn;
                    if (reqresponse) {
                        let headers = new Headers();
                        headers.append("Accept", "application/json");
                        //  todo: delegate to one-server-ha oneview
                        headers.append("Authorization", "Basic " + apitoken?.token);
                        headers.append("Content-Type", "text/plain");
                        /**
                         * Here we invoke caller_lookup API. 
                         * This will be invoke if consolidated_api_invocation is set to true in settings.json
                         */
                        const response = serverone.get({
                            path: consolidated_api_one + "?phone=" + reqresponse.number + "&type=Patient" + "&dnis=" + reqresponse.dnis,
                            headers: headers
                        })
                            .then((resp: any) => resp)
                            .catch((responseerror: any) => {
                                log.error("one-epic", "patientEpic Error", responseerror);
                                // SEND to ALERT notificaiton/NOC servers for critical error on no active server
                                if (responseerror?.status === 0) {
                                    if (alertnotification?.isEnabled()) {
                                        var timestamp = new Date().toJSON();
                                        alertnotification.notify({
                                            "error_code": "930-31",
                                            "error_type": "SERVER_ERROR",
                                            "error_description": "Unable to reach active servers",
                                            "error_supertype": "SERVER_FAILS",
                                            "error_detail": "Unable to reach any of server for retring data ",
                                            "alert": "Yes",
                                            "timestamp": timestamp,
                                            "params": responseerror
                                        });
                                    }
                                }
                                /**
                                 * Creating the error object for caller_lookup API in case of failure scenarios.
                                 */
                                let subjecterror: ErrorObject = {
                                    source: "caller_lookup",
                                    type: "error",
                                    status: responseerror?.status,
                                    erroritems: responseerror?.errors,
                                    error_date: errorDate,
                                    error_time: errorTime
                                };
                                return subjecterror;
                            })
                        respreturn = from(response);
                    } else {
                        respreturn = from([]);
                    }
                    log.debug("one-epic", "patientEpic response", respreturn);
                    return respreturn;
                }
                return getRequest(dataresponse).
                    pipe(
                        flatMap((response: any) => {
                            /**
                             * callerResponse contains full response of caller_lookup API
                             */
                            const callerResponse = response && response?.output && response?.output?.results && response?.output?.results?.length > 0 ? response?.output?.results[0] : {}
                            //Transform Subject 
                            const subjectResponse = TransformResponse(callerResponse?.Patient_Lookup, context);
                            //Setting Subject data to store in Redux
                            const actions: any = [
                                pushToSubject(subjectResponse.subjectdata)
                            ];
                            //Fetching selected subject if the browser is refreshed for Subject
                            const selected = subjectResponse?.subjectdata?.find(
                                (item: any) => item?.id === dataresponse?.subjectid
                            );
                            if (selected && 'id' in selected) {
                                actions.push(setSelectedAction(selected));
                                actions.push(setPatientSelectedAction(selected));
                            }
                            //Fetching selected source if the browser is refreshed for Source
                            const sourceselected = subjectResponse?.subjectdata?.find(
                                (item: any) => item?.id === dataresponse?.sourceid
                            );
                            if (sourceselected && 'id' in sourceselected) {
                                actions.push(sourceAddAction(sourceselected));
                                actions.push(sourceSelectAction(sourceselected?.id));
                            }
                            //Making skeleton to false
                            let skeletonsource: Skeleton = {
                                subject_skeleton: false
                            }
                            actions.push(pushToSkeleton(skeletonsource));


                            //Transform Source 
                            const sourceResponse = TransformCaller(callerResponse?.caller_details, context);
                            actions.push(pushtoSETCallerDBPatient(sourceResponse.sourcedata));
                            //Fetching selected source if the browser is refreshed for Source
                            const stransformselected = sourceResponse?.sourcedata?.find(
                                (item: any) => item?.id === dataresponse?.sourceid
                            );
                            if (stransformselected && 'id' in stransformselected) {
                                //actions.push(sourceAddAction(selected));
                                actions.push(sourceSelectAction(stransformselected?.id));
                            }
                            //Making skeleton to false
                            let sskeletonsource: Skeleton = {
                                source_skeleton: false
                            }
                            actions.push(pushToSkeleton(sskeletonsource));

                            //Fetching entity details from caller_lookup response
                            const entity_arr = callerResponse?.entity_details && callerResponse?.entity_details[0];
                            //Transform entity details
                            const callingResponse = TransformCallerDestResponse(entity_arr, context);
                            actions.push(setAction(callingResponse?.calldest));
                            //clear skeleton for callerdestination
                            let skeletoncallerdest: Skeleton = {
                                callingDestination_skeleton: false
                            }
                            actions.push(pushToSkeleton(skeletoncallerdest));


                            // check for error messages.
                            if (response && (response.status >= 400 || response.type == "error")) {
                                    actions.push(addAction(response));
                            }
                            //Disposition Framework
                            if (response && response?.status == 200) {
                                //Success Dispostion
                                let disp: Disposition = { value: "171" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    disp.meta00 = agentIdValue;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta01 = response?.status;
                                disp.meta02 = 'client';
                                actions.push(pushToDisposition(disp));
                            }else{
                                //Partial/Failure Scenario Dispostion
                                let disp: Disposition = { value: "971" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    disp.meta00 = agentIdValue;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta01 = response?.status;
                                disp.meta02 = 'client';
                                actions.push(pushToDisposition(disp));
                            }
                            /**
                             * Retreiving sub-api responses from caller_lookup response
                             */
                            response?.output?.progress?.map(
                                (e: any) => {
                                    let value = e?.split(":");
                                    let statusvalue = e?.split(" ");
                                    let statuscode = value[1]?.replace(/\s/g, "");
                                    if(value && value?.length > 0 && value[0].includes('patient_search_global')){
                                        if (statuscode !== "true200") {
                                            let disp: Disposition = { value: "972" }
                                            if (contact_center_type && contact_center_type === 'five9') {
                                                let agentIdValue = sessionStorage.getItem("agentName");
                                                disp.meta00 = agentIdValue;
                                                disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                            } else {
                                                disp.meta00 = agentId;
                                                disp.dial_list_uid = state$.value.choosecaller?.callId;
                                            }
                                            disp.meta01 = statusvalue[1];
                                            disp.meta03 = 'client';
                                            actions.push(pushToDisposition(disp));
                                        }
                                    }

                                    if(value && value?.length > 0 && value[0].includes('caller_details')){
                                        if (statuscode !== "true200") {
                                            let disp: Disposition = { value: "973" }
                                            if (contact_center_type && contact_center_type === 'five9') {
                                                let agentIdValue = sessionStorage.getItem("agentName");
                                                disp.meta00 = agentIdValue;
                                                disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                            } else {
                                                disp.meta00 = agentId;
                                                disp.dial_list_uid = state$.value.choosecaller?.callId;
                                            }
                                            disp.meta01 = statusvalue[1];
                                            disp.meta03 = 'client';
                                            actions.push(pushToDisposition(disp));
                                        }
                                    }

                                    if(value && value?.length > 0 && value[0].includes('entity_details')){
                                        if (statuscode !== "true200") {
                                            let disp: Disposition = { value: "974" }
                                            if (contact_center_type && contact_center_type === 'five9') {
                                                let agentIdValue = sessionStorage.getItem("agentName");
                                                disp.meta00 = agentIdValue;
                                                disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                            } else {
                                                disp.meta00 = agentId;
                                                disp.dial_list_uid = state$.value.choosecaller?.callId;
                                            }
                                            disp.meta01 = statusvalue[1];
                                            disp.meta03 = 'client';
                                            actions.push(pushToDisposition(disp));
                                        }
                                    }
                                }
                            );
                            return actions;
                        })
                    )
            })
        )
    }
);


//ADPAC-328
export const selectDrawer = (context: any) => (
    (action$: ActionsObservable<any>) => {
        return action$.pipe(
            ofType(Types.PushtoSubject),
            map(action => pushToDrawer(true)),
        )
    }
);



export const healthAlert = (context: any) => (
    (action$: ActionsObservable<any>) => {
        const errorTime = format(new Date(), 'LT');
        const errorDate = format(new Date(), 'LL');
        const { server,
            log,
            alertnotification,
            settings
        } = context;
        return action$.pipe(
            ofType(Types.HEALTHALERT),
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the employee request
                 */
                const dataresponse: any = action.payload;
                log.debug("one-epics", "healthAlert request", dataresponse);
                const healthAlertCall = (payload: any) => {
                    const { servers } = settings;
                    const { locations = [] } = servers;
                    const healthCheck = locations[0]?.base+"healthcheck";
                    log.debug('healthcheck ', 'API', healthCheck);
                    const resp = axios.get(`${healthCheck}`)
                    .then((response: any) => {
                        log.debug('HEALTH CHECK SUCCESS: ', 'Agenta health check passed with status code:', response)
                        return response;
                      })
                    .catch((response: any) => {
                        //Check the Side B server healthcheck
                        if(locations?.length >= 2){
                            const healthCheckTwo = locations[1]?.base+"healthcheck";
                            const resptwo = axios.get(`${healthCheckTwo}`)
                            .then((response: any) => {
                                log.debug('HEALTH CHECK SUCCESS: ', 'Agenta health check passed with status code:', response)
                                return response;
                            })
                            .catch((response: any) => {
                                if(payload?.agentId) {
                                    log.debug('healthAlert ', 'Response', response);
                                    let alerterror: ErrorObject = {
                                        source: healthCheck,
                                        type: "error",
                                        status: 400,
                                        erroritems: [],
                                        error_date: errorDate,
                                        error_time: errorTime
                                    };
                                    
                                    // A brief description on how you can troubleshoot our two common errors seen here.
                                    console.error('HEALTH CHECK ERROR: Unable to reach the Agenta server. If cert error (\'ERR_CERT_AUTHORITY_INVALID\'), browse the request URL and accept the certificate. If \'ERR_NAME_NOT_RESOLVED\', verify connection to UPMC server environment.');
                                    return alerterror;
                                }
                            });
                            return resptwo;
                        }else{
                            if(payload?.agentId) {
                                log.debug('healthAlert ', 'Response', response);
                                let alerterror: ErrorObject = {
                                    source: healthCheck,
                                    type: "error",
                                    status: 400,
                                    erroritems: [],
                                    error_date: errorDate,
                                    error_time: errorTime
                                };
                                
                                // A brief description on how you can troubleshoot our two common errors seen here.
                                console.error('HEALTH CHECK ERROR: Unable to reach the Agenta server. If cert error (\'ERR_CERT_AUTHORITY_INVALID\'), browse the request URL and accept the certificate. If \'ERR_NAME_NOT_RESOLVED\', verify connection to UPMC server environment.');
                                return alerterror;
                            }
                        }
                    });
                    //log.debug("one-epics", "Cherwell response", response);
                    return from(resp);
                }
                return healthAlertCall(dataresponse).pipe(
                    flatMap((response: any) => {
                        log.debug('healthAlert ','Response::', response);
                        const actions: any = [];
                        if (response && response?.type && response?.type === 'error') {
                            actions.push(setNotificationAction({
                                healthCheckUrl: response?.source,
                                notifiy: true
                            }))
                        }
                        return actions;
                    })
                )
            })
        )
    }

);


